import { FunctionComponent } from 'react';
import { useSelector } from '@cbridge-utils/react-redux';
import { NavigationBlockItem } from '@cbridge-tools/navigation-block';
import { isMatchedPathnameSelector } from '@cbridge-packages/routing';
import { PolicyProtection } from '@cbridge-packages/auth';
import { StreamNodeContextMenu } from '../contextMenu/StreamNodeContextMenu';
import { INodeItemProps } from './NodeItem.interface';

export const NodeItem: FunctionComponent<INodeItemProps> = ({ item }) => {
  const { label, href } = item;

  const isSelected = useSelector(isMatchedPathnameSelector, { pattern: href });

  return (
    <NavigationBlockItem
      label={label}
      isSelected={isSelected}
      href={href}
      hoverAction={
        <PolicyProtection>
          <StreamNodeContextMenu item={item} />
        </PolicyProtection>
      }
    />
  );
};
